// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".approval-checklist-detail .el-form .el-form-item__content[data-v-06f41c76] {\n  width: 210px;\n}\n.approval-checklist-detail .el-form .el-date-editor--datetime[data-v-06f41c76] {\n  width: 210px !important;\n}\n", ""]);
// Exports
module.exports = exports;
